import { render, staticRenderFns } from "./narrow-preferences-panel.vue?vue&type=template&id=e8d21532&scoped=true&"
import script from "./narrow-preferences-panel.vue?vue&type=script&lang=js&"
export * from "./narrow-preferences-panel.vue?vue&type=script&lang=js&"
import style0 from "./narrow-preferences-panel.vue?vue&type=style&index=0&id=e8d21532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d21532",
  null
  
)

export default component.exports